import React from "react";
import styled from "styled-components";

import theme from "../../styles/theme";

const Wrapper = styled.div`
  display: none;
  ${() => theme.media.desktopUp`
    display: inherit;
`};
`;

const DesktopOnly = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

export default DesktopOnly;
